var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_122_40804)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 51.4375H38C32.225 51.4375 31.15 48.75 30.875 46.1375L29.9375 36.125C29.8 34.8125 29.7625 32.875 31.0625 31.425C32.1875 30.175 34.05 29.575 36.75 29.575H49.25C51.9625 29.575 53.825 30.1875 54.9375 31.425C56.2375 32.875 56.2 34.8125 56.0625 36.1375L55.125 46.125C54.85 48.75 53.775 51.4375 48 51.4375ZM36.75 31.4375C34.6375 31.4375 33.1875 31.85 32.45 32.675C31.8375 33.35 31.6375 34.3875 31.8 35.9375L32.7375 45.95C32.95 47.925 33.4875 49.5625 38 49.5625H48C52.5 49.5625 53.05 47.925 53.2625 45.9375L54.2 35.95C54.3625 34.3875 54.1625 33.35 53.55 32.675C52.8125 31.85 51.3625 31.4375 49.25 31.4375H36.75Z",
    fill: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 31.4375C47.4875 31.4375 47.0625 31.0125 47.0625 30.5V29.5C47.0625 27.275 47.0625 26.4375 44 26.4375H42C38.9375 26.4375 38.9375 27.275 38.9375 29.5V30.5C38.9375 31.0125 38.5125 31.4375 38 31.4375C37.4875 31.4375 37.0625 31.0125 37.0625 30.5V29.5C37.0625 27.3 37.0625 24.5625 42 24.5625H44C48.9375 24.5625 48.9375 27.3 48.9375 29.5V30.5C48.9375 31.0125 48.5125 31.4375 48 31.4375Z",
    fill: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 43.9375C39.5625 43.9375 39.5625 41.8125 39.5625 40.5375V39.25C39.5625 37.4875 39.9875 37.0625 41.75 37.0625H44.25C46.0125 37.0625 46.4375 37.4875 46.4375 39.25V40.5C46.4375 41.8 46.4375 43.9375 43 43.9375ZM41.4375 38.9375C41.4375 39.0375 41.4375 39.15 41.4375 39.25V40.5375C41.4375 41.825 41.4375 42.0625 43 42.0625C44.5625 42.0625 44.5625 41.8625 44.5625 40.525V39.25C44.5625 39.15 44.5625 39.0375 44.5625 38.9375C44.4625 38.9375 44.35 38.9375 44.25 38.9375H41.75C41.65 38.9375 41.5375 38.9375 41.4375 38.9375Z",
    fill: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 41.4626C45.0375 41.4626 44.625 41.1126 44.575 40.6376C44.5125 40.1251 44.875 39.6501 45.3875 39.5876C48.6875 39.1751 51.85 37.9251 54.5125 35.9876C54.925 35.6751 55.5125 35.7751 55.825 36.2001C56.125 36.6126 56.0375 37.2001 55.6125 37.5126C52.6875 39.6376 49.2375 41.0001 45.6125 41.4626C45.575 41.4626 45.5375 41.4626 45.5 41.4626Z",
    fill: "#EE1C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 41.4751C40.4625 41.4751 40.425 41.4751 40.3875 41.4751C36.9625 41.0876 33.625 39.8376 30.7375 37.8626C30.3125 37.5751 30.2 36.9876 30.4875 36.5626C30.775 36.1376 31.3625 36.0251 31.7875 36.3126C34.425 38.1126 37.4625 39.2501 40.5875 39.6126C41.1 39.6751 41.475 40.1376 41.4125 40.6501C41.375 41.1251 40.975 41.4751 40.5 41.4751Z",
    fill: "#EE1C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_122_40804",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_40804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_40804",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesicon);
export default __webpack_public_path__ + "static/media/salesicon.222b864ec2f3d79a63f8368acdd547ee.svg";
export { ForwardRef as ReactComponent };